export default {
  // apiUrl: "http://localhost:12000/api/klimapartner",
  apiUrl: "https://www.klimakost.no/api/klimapartner",
  // apiUrl: "https://klimakost-staging.gaiageo.dev/api/Klimapartner",
  // apiUrl: "https://klimakost.gaiageo.dev/api/Klimapartner",
  exportUser: {
    name: "exportUser",
    pw: "Fu^jQ&t@4A8mTVH2",
  },

  pfdRegion: {
    2: { title: "Agder", pdf: [] },
    3: {
      title: "Rogaland",
      pdf: [
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2018_rogaland.pdf",
      ],
    },
    4: {
      title: "Viken",
      pdf: [],
    },
    5: {
      title: "Trøndelag",
      pdf: [],
    },
    6: {
      title: "Vestland",
      pdf: [
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2016_vestland.pdf",
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2017_vestland.pdf",
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2018_vestland.pdf",
      ],
    },
    7: {
      title: "Troms",
      pdf: [
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2016_troms.pdf",
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2017_troms.pdf",
        process.env.PUBLIC_URL +
          "/static/old_pdfs/klimaregnskap_2018_troms.pdf",
      ],
    },
  },

  omRegionenText: {
    0: "<p>Klimapartnere er Norges viktigste partnerskap for grønn næringsutvikling. Det finnes nå partnerskap i hele landet, med til sammen godt over 200 partnervirksomheter. Vår visjon er at Norge lykkes med omstilling for å nå 1,5 graders-målet. Norges nåværende klimamål er ikke nok, og flere fylker, byer og kommuner er langt mer ambisiøse. Alle våre partnere utfordres dessuten om å bli fossilfri og kutte sine direkte utslipp innen 2030. Dette er en oppfordring svært mange allerede har tatt på strak arm og over en av 4 partnere er allerede i mål! Det vet vi, fordi vi måler. Klimaregnskap er ryggraden i den forpliktende metoden vi benytter. I Klimapartnere benyttes klimaregnskap som et effektivt verktøy til både systematisk klimagassreduksjon og grønn næringsutvikling. Vi er i rask vekst og stadig flere slutter seg til bruk av metoden. Vi takker alle for en strålende innsats med årets rapportering og nye digitale plattform.</p>",
    1: "<p>Klimapartnere Troms ble stiftet 9. februar 2017 og et regionalt partnerskap bestående av akademia, offentlig og privat sektor som sammen vil være pådrivere til å redusere klimagassutslipp. Det er en arena for å utvikle kunnskap om klimautfordringer i nord.</p>",
    2: "<p>Agder er en region i økonomisk og befolkningsmessig vekst. De siste ti årene har Agder vært en av landets raskest voksende regioner i folketall.<br /><br />Agder har et variert og konkurransedyktig arbeids- og næringsliv. Industrinæringer som prosess- og mekanisk industri og leverandørindustri for olje- og gassvirksomhet står særlig sterkt. Det er et stort potensial for bærekraftig vekst gjennom å kombinere regionens sterke teknologikompetanse og store overskudd av fornybar kraft. <br /><br /> Klimaendringer er en global utfordring. Agder må både håndtere hendelser som følge av mer ekstremvær og gjennomføre utslippskutt for å oppfylle Parisavtalen. Transport står for mest klimagassutslipp i Agder, og det er derfor i denne sektoren de største utslippskuttene må tas. Samtidig er økt mobilitet sentralt for å bedre levekår, skape et felles bo- og arbeidsmarked og tilrettelegge for verdiskaping. Næringslivet i regionen har store muligheter for å utvikle nye klimavennlige løsninger og produkter, og dermed nye grønne arbeidsplasser. For å få dette til må Agder styrke innsatsen innen forskning, utvikling og innovasjon. Klimapartnere Agder bidrar til at regionen reduserer sine klimagassutslipp gjennom sitt offentlige-private partnerskap, og fokuserer på å øke grønn verdiskapning i regionen. Klimapartnere ble etablert i Arendal i 2009, partnerskapet er nå etablert over hele landet over hvor hver region har sitt regionale fokus. <br /><br /> I flere år har Klimapartnerne i Agder ført klimaregnskap. Sammenlikningsgrunnlaget det siste året er utfordrende å kommentere på grunn av situasjonen med Covid-19. Antall leverte klimaregnskap i regionen er færre sammenliknet med tidligere år, selv om antall partnere er omtrent på det jevne med tidligere år.  Vi ønsker å se at den overordnede trenden viser en nedgang i direkte utslipp hos partnerne, og at flere setter seg mål om å bli fossilfri innen 2030 samt øvrige klimamål.  Potensialet for store utslippskutt ligger i de indirekte utslippene (scope 3) og det er derfor i år et større fokus på, og handlingsrom for partnerne til å rapportere på scope 3 utslippene. Dette er varer og tjenester vi kjøper av leverandører og underleverandører, og som det kan være vanskelig å påvirke direkte. Man kan i større grad påvirke utslippene i scope 1 og scope 2 og derfor er det tradisjonelt det Klimapartnere har hatt størst fokus på. Scope 3 rapportering gir verdifull innsikt rundt verdikjedene til partnerne. I Klimapartnere Agder har vi fokus på grønne innkjøp og vi ser at flere av partnerne våre nå benytter sin innkjøpsmakt til å stille krav i sin egen verdikjede, noe som igjen også vil påvirke utslippene i scope 3, selv om disse er mer kompliserte å måle.<br /><br /> Klimaregnskapet for Agder viser en nedgang i totale utslipp på -24.6 % fra år 2018 til 2019, når vi har tatt ut nye medlemmer og frivillig rapportering i scope 3.  Utslippsreduksjonene skyldes i hovedsak reduksjon i direkte utslipp på fossile utslippskilder (scope 1) og indirekte utslipp (scope 3), i hovedsak reduksjon i antall tjenestereiser.  Det er noe manglende rapportering på forbrukstall fra en våre partnere og dette gir store utslag i utslippsreduksjon totalt sett.</p>",
    3: "<p>Rogaland er en dynamisk energi, industri- og matregion. Regionen har vært preget av flere svingninger i markedet som gjør det det enda mer aktuelt å være på ballen i den grønne omstillingen. Rogaland har de nødvendige forutsetningene for å skape omstillingen vi behøver. Vi har allerede mange gode eksempler på at dette skjer hos våre partnere. Det er viktig å synliggjøre de nødvendige tiltakene som blir utført innen både det offentlige og private, skape treffpunkter og kommunikasjon mellom partnerne, og få satt tema som bidrar til omstillingen på den politiske agendaen.<br /><br/>Siden klimaregnskapet for 2018, har regionen vokst med flere nye partnere. Vårt ønske og mål er å kunne følge utviklingen fra år til år og se at den overordnede trenden viser en nedgang i direkte utslipp, og at flere setter seg mål om å bli fossilfri innen 2030 samt øvrige klimamål. Det er gledelig at alle våre partnere i Klimapartnere Rogaland ønsker å være ledestjerner i den viktige jobben vi har foran oss. <br /><br/>Det er viktig å understreke at rapportering for klimaregnskap kan gi et feilaktig bilde av situasjonen. 80 % av utslippene i Norge er linket til indirekte utslipp (Scope 3). Dette er varer og tjenester vi kjøper av leverandører og underleverandører, og som det kan være vanskelig å påvirke direkte. Man kan i større grad påvirke utslippene i scope 1 og scope 2 og derfor er det tradisjonelt det Klimapartnere har hatt størst fokus på. Nå ser vi heldigvis at virksomheter er flinkere til å rapportere på scope 3. Dette gir verdifull innsikt rundt verdikjedene til selskapene. I Klimapartnere sammenheng ser vi at flere av partnerne våre nå benytter sin innkjøpsmakt til å stille krav i sin egen verdikjede, noe som igjen også vil påvirke utslippene i scope 3, selv om disse er mer kompliserte å måle.<br /><br/>Klimaregnskapet for Rogaland viser en oppgang i utslipp på total 47,1 % fra 2018 til 2019, når vi har tatt ut nye medlemmer og rapportering på frivillig i scope 3. Forklaringen til dette er at vi forventer en økning de første 3-4 årene ettersom virksomhetene blir flinkere til å hente inn tall og bli kjent med klimaregnskap. Deretter, og etter hvert som virksomhetene blir flinkere til å sette mål om fossilfri 2030 (kutte utslipp i scope 1) så regner vi med å se en nedgang i både direkte utslipp på fossil (scope 1) og direkte utslipp på energi (scope 2).<br /><br/>Regionsleder i Rogaland er Christian Herheim, som har jobbet mange år i olje og gass- bransjen med kommunikasjon, markedsføring og strategi. Videre har han vært gründer for forretningsutvikling av fornybar energi og CCS. På teamet har han Anne Marie Lofthus som prosjektleder. I tillegg har hun i år vært prosjektleder for digitalisering av det nasjonale klimaregnskapet. <br /><br/>Vi gleder oss over at vi nå har fått klimaregnskapet i et heldigitalt og interaktivt format der man kan gjøre dypdykk ned i den enkelte virksomhet, men også få et helhetlig bilde over utviklingen i hver enkelt region og nasjonalt. Vi håper flere vil tilslutte seg Klimapartnere Rogaland, og være med å skape den nødvendige omstillingen vi trenger mot 2030 i regionen.</p>",
    4: "<p>Klimapartnere Østfold - Viken hadde sitt stiftelses- og signeringsmøte den 18.juni 2019 på Litteraturhuset i Fredrikstad. I dag har vi et partnerskap – bestående av 20 aktører fra det private næringslivet, offentlige, interesseorganisasjoner og akademia. Med andre ord, en god refleksjon på hvordan Klimapartnere jobber bredt.</p>",
    5: "<p>Klimapartnere Trøndelag hadde oppstartsmøte i Trondheim 11. september 2019, med offensive ledere fra private bedrifter, akademia, organisasjoner – og de sentrale offentlige aktørene. Siden har partnereskapet vokst og bredd seg, og det er spesielt verdt å nevne Overhalla og miljøet i Skogmo industripark som hadde eget signeringsmøte med 7 nye partnere i februar 2020. Vi presenterer i år vårt første klimaregnskap fra regionen. For mange av partnerne har det medført mye arbeid og en bratt læringskurve, for enkelte andre en fortsettelse av tidligere praksis. <br />Felles for alle er en genuin interesse for å få bedre innsikt i konsekvensene av egne aktiviteter og bruke det aktivt til endringer som gir bedre ressursutnyttelse, reduserte utslipp og kostnader. Positive tilbakemeldinger om økt kompetanse og motivasjon i egne rekker bærer bud om tiltak internt, men vel så interessant har det vært å se økt bevissthet knyttet til verdikjeder: Dialog mellom kunder og leverandører, og nye interessante partnerskap. Det er vår overbevisning at flere av partnerne i Trøndelag vil være synlige som ledere i det grønne skiftet i årene som kommer.<br />Vi ser frem til fortsettelsen, med ambisiøse klimamål, konkrete tiltak og reduserte utslipp i en offensiv region!<br />Jon A. Svenningsen, regionleder Klimapartnere Trøndelag</p>",
    6: '<p>Klimapartnere Vestland er en partnerregion i sterk vekst. Fra januar 2020 ble partnerskapet en del av nye Vestland fylkeskommune, og utvidet samtidig virksomheten fra Hordaland til å omfatte hele det nye fylket. I august 2020 hadde vi oppstartsmøte for vår nye avdeling nord i fylket, med en egen ansatt med base i Florø. Klimapartnere Vestland omfatter nå nærmere 60 virksomheter, og stadig flere slutter seg til partnerskapet. <br /><br/>Klimaregnskapet for 2019 er vårt mest omfattende klimaregnskap noensinne, og vi har med oss flere partnere som rapporterer for første gang. Det er en stor styrke at så mange av partnerne har satt seg høye målsettinger, og jobber systematisk for å nå dem.  Årets klimaregnskap viser at antall fossilfrie partnere har gått opp, mens de direkte utslippene går ned. Vi er stolte av den innsatsen som er lagt ned for å få dette til. <br /><br/>Vi utfordrer alle våre partnere til å slutte seg til målsettingen "Nullutslipp 2030", som politikerne i Vestland Fylke har stilt seg i bresjen for. Klimaregnskapet er vårt viktigste verktøy for å nå dette målet - gjennom utslippskutt, grønn forretningsutvikling og innovasjon. Vi takker alle våre partnere for innsatsen!</p>',
  },

  regionId: {
    0: "Nasjonal",
    1: "Region Troms",
    2: "Region Agder",
    3: "Region Rogaland",
    4: "Region Viken",
    5: "Region Trøndelag",
    6: "Region Vestland",
    7: "Region Nordland",
    8: "Region Innlandet",
    9: "Region Oslo",
    11: "Møre og Romsdal",
  },

  regionImg: {
    0: process.env.PUBLIC_URL + "/static/region_img/nasjonal.JPG",
    2: process.env.PUBLIC_URL + "/static/region_img/agder.jpg",
    3: process.env.PUBLIC_URL + "/static/region_img/rogaland.jpg",
    4: process.env.PUBLIC_URL + "/static/region_img/viken.jpeg",
    5: process.env.PUBLIC_URL + "/static/region_img/trondelag.png",
    6: process.env.PUBLIC_URL + "/static/region_img/vestland.jpg",
  },

  transportIconList: [
    {
      title: "Fossile",
      img: process.env.PUBLIC_URL + "/static/cars/fossil_kjoretoy.png",
      text: ["Personbiler:", "Kjøretøy over 3,5 tonn:", "Andre kjøretøy:"],
      rowName: [
        "fossekshybpersonbiler",
        "fossekshyblastebiler",
        "fossekshybkjoretoy"
      ],
    },

    {
      title: "Fossilfrie",
      img: process.env.PUBLIC_URL + "/static/cars/Personbil.png",
      text: ["Personbiler:", "Kjøretøy over 3,5 tonn:", "Andre kjøretøy:"],
      rowName: [
        "hybridepersonbiler",
        "hybridelastebiler",
        "hybridekjoretoy",
      ],
    },

    {
      title: "Nullutslippskjøretøy",
      img: process.env.PUBLIC_URL + "/static/cars/fossilfrie-kjoretoy.png",
      text: ["Personbiler:", "Kjøretøy over 3,5 tonn:", "Andre kjøretøy:"],
      rowName: [
        "nullutslippspersonbiler",
        "nullutslippslastebiler",
        "nullutslippskjoretoy",
      ],
    },
  ],

  legend: {
    fossilfri: {
      title: "Fossilfri",
      img:
        process.env.PUBLIC_URL +
        "/static/green_icons/Fosilfri-klimapartner.png",
      description:
        "Alle direkte utslipp (scope 1) er fjernet; direkte transport-, energi- og prosessutslipp.",
    },
    karbonnoytral: {
      title: "Karbonnøytral",
      img:
        process.env.PUBLIC_URL + "/static/green_icons/carbonneutral_icon.png",
      description:
        "Bedriften kjøper klimakreditter for å kompensere for egne utslipp som ikke er kuttet.",
    },
    lokasjonsbasert: {
      title: "Lokasjonsbasert",
      img: process.env.PUBLIC_URL + "/static/scopes/scope_2.png",
      description:
        "Utslippsfaktoren for forbrukt elektrisitet, baseres her på utslipp knyttet til produksjon innenfor et spesifikt område. Norsk strøm regnes her som nesten utslippsfri.",
    },
    markedsbasert: {
      title: "Markedsbasert",
      img: process.env.PUBLIC_URL + "/static/scopes/scope_2.png",
      description:
        "Utslippsfaktoren for elektrisitet, baseres her på det europeiske kraftmarkedet. Norsk strøm har her en høy utslippsfaktor. Ved kjøp av opprinnelsesgaranti kan man kjøpe rettigheter til fornybar strøm og nulle ut utslipp.",
    },
  },

  iconList: [
    {
      maal: "maal1",
      title: "Fossilfri 2030",
      green:
        process.env.PUBLIC_URL +
        "/static/green_icons/Fosilfri-klimapartner.png",
      orange:
        process.env.PUBLIC_URL +
        "/static/orange_icons/Fosilfri-klimapartner.png",
    },

    {
      maal: "maal2",
      title: "Utslippsfri transport av varer og tjenester",
      green:
        process.env.PUBLIC_URL + "/static/green_icons/Fossilfrie-kjoretoy.png",
      orange:
        process.env.PUBLIC_URL + "/static/orange_icons/Fossilfrie-kjoretoy.png",
    },

    {
      maal: "maal3",
      title: "Plan for grønne innkjøp",
      green:
        process.env.PUBLIC_URL + "/static/green_icons/Gronn-innkjopsplan.png",
      orange:
        process.env.PUBLIC_URL + "/static/orange_icons/Gronn-innkjopsplan.png",
    },

    {
      maal: "maal4",
      title: "Plan for reduksjon av energi i bygg",
      green:
        process.env.PUBLIC_URL + "/static/green_icons/Fossilfri-oppvarming.png",
      orange:
        process.env.PUBLIC_URL +
        "/static/orange_icons/Fossilfri-oppvarming.png",
    },
    {
      maal: "maal5",
      title: "Plan for reduksjon/håndtering av avfall",
      green: process.env.PUBLIC_URL + "/static/green_icons/Avfallstiltak.png",
      orange: process.env.PUBLIC_URL + "/static/orange_icons/Avfallstiltak.png",
    },
    {
      maal: "maal6",
      title: "Miljøsertifisert",
      green:
        process.env.PUBLIC_URL + "/static/green_icons/Miljosertifisering.png",
      orange:
        process.env.PUBLIC_URL + "/static/orange_icons/Miljosertifisering.png",
    },

    {
      maal: "maal7",
      title: "Plan for å redusere utslipp fra reiseaktivitet",
      green: process.env.PUBLIC_URL + "/static/green_icons/Klimaavtrykk.png",
      orange: process.env.PUBLIC_URL + "/static/orange_icons/Klimaavtrykk.png",
    },
    {
      maal: "maal8",
      title: "Plan for bruk/innføring av sirkulære verdikjeder",
      green: process.env.PUBLIC_URL + "/static/green_icons/Miljostyring.png",
      orange: process.env.PUBLIC_URL + "/static/orange_icons/Miljostyring.png",
    },
  ],

  regioner: [
    {
      groupid: 0,
      name: "Nasjonal",
      url: "nasjonal",
      logo: "norge_logo",
    },

    {
      groupid: 2,
      name: "Agder",
      url: "agder",
      logo: "Agder_logo",
    },
    {
      groupid: 3,
      name: "Rogaland",
      url: "rogaland",
      logo: "Rogaland_logo",
    },
    {
      groupid: 1,
      name: "Troms",
      url: "troms",
      logo: "Troms_logo",
    },
    {
      groupid: 5,
      name: "Trøndelag",
      url: "trøndelag",
      logo: "Trøndelag_logo",
    },

    {
      groupid: 6,
      name: "Vestland",
      url: "vestland",
      logo: "Vestland_logo",
    },
    {
      groupid: 4,
      name: "Viken",
      url: "viken",
      logo: "Viken_logo",
    },
    {
      groupid: 7,
      name: "Nordland",
      url: "nordland",
      logo: "Nordland_logo",
    },
    {
      groupid: 8,
      name: "Innlandet",
      url: "innlandet",
      logo: "Innlandet_logo",
    },
    {
      groupid: 9,
      name: "Oslo",
      url: "oslo",
      logo: "Oslo_logo",
    },
    {
      groupid: 11,
      name: "Møre og Romsdal",
      url: "Møre og Romsdal",
      logo: "more_logo",
    },
    {
      groupid: -1,
      name: "Klimaregnskap",
      url: "klimaregnskap",
      logo: "kp_logo",
    },
    {
      //groupid: 9,
      groupid: 10,
      name: "FAQ",
      url: "faq",
      logo: "kp_logo",
    },
  ],

  boxTextTitles: {
    klimavisjonBoks: ["Klimavisjon"],
    spydspissProsjekterBoks: ["Spydspissprosjekter"],
    bestePraksis: ["Beste praksis"],
    utfortKlimaBoks: ["Gjennomførte klimatiltak "],
    tjenesterProdukterBoks: ["Tjenester og produkter for lavutslippsamfunnet"],
    kommunikasjonBoks: ["Kommunikasjon av klimaarbeid"],
  },

  APIdescription: {
    elType: { marketBased: 1, locationBased: 2 },
    nasjonal: 0,
    klimaregnskap: -1,
    agder: 2,
    rogaland: 3,
    "troms": 1,
    trøndelag: 5,
    vestland: 6,
    viken: 4,
    nordland: 7,
    innlandet: 8,
    oslo: 9,
    // faq: 9,
    "Møre og Romsdal": 11,
    faq: 10,
  },

  klimaregnskapText: {
    KPDescription:
      "Klimapartnere utarbeider klimaregnskap årlig, for å vise utslippsutvikling både per partner og samlet for regionen.",
    KPText:
      "Dette er en av hovedforpliktelsene i partnerskapet. Klimaregnskapet brukes som basis for å motivere og identifisere hvor partnere har forbedringspotensiale og mulighet for utslippsreduksjon og nye grønne forretningsområder. <br/> <br/> Alle partnere utfordres til å bli fossilfri (direkte utslipp) senest innen 2030. <br/> <br/> ",
    metodeFirstDescription: "METODE FOR KLIMAREGNSKAP",
    metodeFirstText:
      "Klimapartnere benytter seg av Klimakost, som er et verktøy utviklet og levert av Asplan Viak. Klimakost gjør det mulig å utarbeide klimaregnskap basert på kjente standarder, som  GHG-protokollen (Greenhouse gas protocol).<br /><br /> Standarden omfatter følgende klimagasser: CO2 (karbondioksid), CH4 (metan), N2O (lystgass), SF6, HFK- og PFK-gasser. Påvirkningen fra de ulike klimagassene blir regnet om til en felles enhet, tonn CO2-ekvivalenter, for presentasjon i rapporten.",
    metodeSecondDescription: "RAPPORTERING I HENHOLD TIL GHG PROTOKOLLEN",
    metodeSecondText:
      "Klimaregnskapet er inndelt i tre kategorier (scopes) som består av både direkte og indirekte utslippskilder. <br /> <br />Klimapartnere anbefaler alle partnere å bli fossilfrie, noe som betyr at vi har et ekstra høyt fokus på Scope 1. For Scope 2 og 3 er det viktig å ha fokus på forbruket/aktiviteten som gir utslippet, både at man forsøker å redusere aktiviteten (som å redusere avfallsmengder og erstatte reiser med videomøter) og at man finner alternative innkjøp som reduserer indirekte utslipp selv om det ikke synes på et klimaregnskap (som å benytte lokalprodusert mat og byggematerialer).",
    metodeThirdDescription: "FAKTORER BRUKT I UTREGNINGEN",
    metodeThirdText:
      "Klimakostmodellen kombinerer to metodikker i beregningene av klimafotavtrykket:<br /><ul><li>EE-IOA, miljøutvidet kryssløpsmodellering: her oversetter man økonomiske data (NOK matvarer, kontormateriell, IT-utstyr, etc.) til CO2-ekvivalenter.</li><li>LCA, livsløpsvurdering: her oversetter man fysiske enheter (liter drivstoff, kWh energi, pkm flyreiser) til CO2-ekvivalenter</li></ul>Vanlig fremgangsmåte er å benytte LCA på det meste av scope 1- og 2- bidrag, mens EE-IOA vil dekke det brede spekter av scope 3. LCA bør også benyttes på scope 3-bidrag der dette er hensiktsmessig i form av et viktig bidrag og gjennom god tilgjengelighet av data.",
  },

  deviationText: {
    title: "Forklaring av sentrale antagelser i klimaintensiteter",
    description:
      "<p>Løsningen legger opp til obligatoriske og <b>frivillig rapporteringer på scope 3</b> bidrag. Frivillige scope 3 utslipp er i varierende grad inkludert i tidligere rapporteringer, og vil i løsningen kunne skrus av og på for å sikre mest mulig sammenlignbarhet til tidligere år<br /><br />Ved bruk av <b>drivstoff og andre fossile brensler</b> benytter vi i utgangspunktet livsløpsbaserte utslippsintensiteter. Siden hovedvekten av utslippene skjer ved forbrenning legger vi alle utslipp på scope 1 for å gjøre rapportering enklere.<br /><br />Utslippsfaktorer for <b>avfall</b> inkluderer ikke substitusjonseffekter. Dette i tråd med anbefalinger i GHG-protokollen. Dette betyr altså at man ikke regner inn gevinst for at det avfall en virksomhet sender til f.eks. materialgjenvinning vil erstatte jomfruelige materialer.<br /><br />For utslipp fra flyreiser benytter vi en høydefaktor på 2 i tråd med nyeste forskning. Altså alle klimagassutslipp fra fly tillegges dobbelt oppvarmingspotensial. Kilde: Jungbluth, N. & Meili, C. 2018, <i>Recommendations for calculation of the global warming potential of aviation including the radiative forcing index.</i></p>",
  },

  utregningContent: [
    {
      title: "Scope 2 Fysisk perspektiv (lokasjonsbasert metode)",
      description:
        "I følge GHG-protokollen skal fysisk perspektiv inkludere: «Average emission factors representing all electricity production information from geographic boundaries that are not necessarily related to dispatch region, such as state or national borders.»<br /><br />Som fysiske utslippsfaktorer har du blant annet mulighet til å velge norsk eller nordisk produksjonsmiks eller norsk forbruksmiks. Produksjonsmiksen inneholder ikke utslipp fra utenlandsk strøm produksjon som kommer via import, mens forbruksmiksen inneholder brutto forsyning til Norge (sum av produksjon og import).",

      img: process.env.PUBLIC_URL + "/static/scopes/scope_2.png",
      title2: "Scope 2 Markedsbasert perspektiv",
      description2:
        "Beregningen av utslippsfaktor baseres på hvorvidt virksomheten velger å kjøpe opprinnelsesgarantier eller ikke. Ved kjøp av opprinnelsesgarantier dokumenterer leverandøren at kjøpt elektrisitet kommer fra kun fornybare kilder, som gir en utslippsfaktor på 0 gram CO<sub>2</sub>e per kWh.<br /><br />Elektrisitet som ikke er knyttet til opprinnelsesgarantier får en utslippsfaktor basert på produksjonen som er igjen etter at opprinnelsesgarantiene for fornybar andel er solgt. Dette kalles residualmiks. Norsk elektrisitets residualmiks ga for 2018 en utslippsfaktor på 531 gram CO<sub>2</sub>e per kWh. Grunnen til at denne er så høy er fordi Norge selger hoveddelen av opprinnelsesgarantier til utenlandske forbrukere. Det innebærer markedsmessig at norsk vannkraft blir erstattet med en miks av fossil energi.",
    },
    {
      img: process.env.PUBLIC_URL + "/static/scopes/scope_3.png",
      title: "Scope 3",
      description:
        "Vi benytter fysiske faktorer for noen scope 3 kilder som flyreiser og avfallsbehandling. Der fysiske utslippsfaktorer ikke er tilgjengelig benyttes miljøutvidet kryssløpsanalyse (EE-IOA) for økonomiske innsatsfaktorer. I en miljøutvidet kryssløpsanalyse benyttes utslipp og aktivitetsdata for et standard utvalg næringslivs-sektorer (SN2007 /NACE rev2) for å beregne utslippene som ligger bak innkjøpene innen hver sektor. Siden koblingen da vil være på sektornivå er det viktig å være klar over at usikkerheten for resultatene blir større enn for scope 1 og 2. Det er likevel nyttig å ha disse med for å identifisere relativ størrelsesorden og mulige tiltak for å redusere disse bidragene.",
    },
  ],

  scopeContent: [
    {
      img: process.env.PUBLIC_URL + "/static/scopes/scope_1.png",
      title: "Scope 1 - Direkte utslipp",
      description:
        "Denne kategorien inkluderer alle utslippskilder knyttet til driftsmidler der organisasjonen har operasjonell kontroll. Dette inkluderer all bruk av fossilt brensel for stasjonær bruk eller transportbehov.",
    },
    {
      img: process.env.PUBLIC_URL + "/static/scopes/scope_2.png",
      title: "Scope 2 – Indirekte utslipp fra innkjøp av energi",
      description:
        "Scope 2 utslipp inkluderer indirekte utslipp knyttet til innkjøpt elektrisitet og fjernvarme/-kjøling. I henhold til GHG-protokollen skal selskap benytte en såkalt todelt rapportering for elektrisitet. <br /><br /> Det vil si at utslippene beregnes på to ulike måter; ut fra et fysisk perspektiv (lokasjonsbasert) og ut fra et markedsbasert perspektiv. I Norge er strømmen produsert med lave utslipp, slik at ut fra et fysisk perspektiv vil klimagassutslippene ved bruk av strøm være lave og strøm klart mer klimavennlig enn fossil energi. For å trigge økt produksjon av fornybar strøm er det etablert en internasjonal ordning med kjøp og salg av opprinnelsesgarantier, som gir grunnlag for beregningen ut fra et markedsbasert perspektiv.",
    },
    {
      img: process.env.PUBLIC_URL + "/static/scopes/scope_3.png",
      title: "Scope 3 – Andre indirekte utslipp",
      description:
        "Her rapporteres indirekte utslipp knyttet til innkjøpte varer eller tjenester. Dette er utslipp som skjer utenfor virksomhetens område, men som selskapet likevel kan påvirke gjennom sin anskaffelsespraksis. For mange virksomheter representerer scope 3 en betydelig del av klimaregnskapet, men det kan ofte være vanskelig å finne data.",
    },
  ],
};
